import React from 'react';

const ServicesSection: React.FC = () => {
  const services = [
    {
      icon: 'ri-pencil-ruler-2-line',
      title: 'Expert Design Consultation',
      description: 'Our experienced designers work with you to create the perfect office environment that enhances productivity and reflects your brand identity.',
      image: 'https://public.readdy.ai/ai/img_res/f074f9b0c81704919cee7a52a5c0c4a1.jpg'
    },
    {
      icon: 'ri-truck-line',
      title: 'Reliable Delivery',
      description: 'Safe and timely delivery of your office furniture across South Carolina and surrounding states with our professional logistics team.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20delivery%20truck%20with%20office%20furniture%20being%20carefully%20transported%2C%20modern%20logistics%20vehicle%20with%20POG%20branding%20delivering%20desks%20and%20chairs%20to%20commercial%20building&width=400&height=300&seq=delivery-service&orientation=landscape'
    },
    {
      icon: 'ri-tools-line',
      title: 'Professional Installation',
      description: 'Complete installation and setup services ensuring your office furniture is properly configured and ready for immediate use.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20technicians%20installing%20office%20furniture%2C%20assembling%20desks%20and%20chairs%20in%20a%20modern%20commercial%20office%20space%20with%20tools%20and%20equipment%2C%20clean%20professional%20environment&width=400&height=300&seq=installation-service&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Comprehensive <strong>Office Furniture</strong> Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From initial design consultation to final installation, we provide end-to-end office furniture solutions 
            that transform your workspace into a productive and inspiring environment.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="h-48 bg-cover bg-center" style={{ backgroundImage: `url('${service.image}')` }}></div>
              <div className="p-6">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-2xl text-blue-600`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;